import clsx from 'clsx';
import styles from './ImageView.module.scss';

export type ImageViewProps = {
  src?: string;
  alt?: string;
  isFreeSize?: boolean;
  isCircled?: boolean;
  style?: React.CSSProperties;
  loading?: 'eager' | 'lazy';
  objectFit?: 'cover' | 'contain';
  dataTestId?: string;
};

function ImageView({
  src,
  alt,
  isFreeSize = false,
  isCircled = false,
  style,
  loading = 'lazy',
  objectFit = 'cover',
  dataTestId = '',
}: ImageViewProps) {
  const imgClasses = clsx({
    [styles.isFreeSize]: isFreeSize,
    [styles.defaultSize]: !isFreeSize,
    [styles.isCircled]: isCircled,
    [styles.objectFitCover]: objectFit === 'cover',
    [styles.objectFitContain]: objectFit === 'contain',
  });

  return (
    <div className={`${styles.componentStyle}`} style={style}>
      <img src={src} alt={alt} loading={loading} className={imgClasses} data-testid={dataTestId} />
    </div>
  );
}

export default ImageView;
